import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import useInput from "../../../hooks/useIndicatorInput";
import IsRequiredModule from "./IsRequiredModule";
import { restrictAlphabets } from "../../../../utils/Utils";

const SuperTrendSetting = (props) => {
  const { indicator, updateIndicator, t } = props;

  // period_num = Period (Default 10)
  const [period, bindPeriod, setPeriod] = useInput(indicator.period_num, 0);
  
  // value2 = Multiplier (Default 3)
  const [multiplier, bindMultiplier, setMultiplier] = useInput(indicator.value2, 0);

  useEffect(() => {
    updateIndicator({
      ...indicator,
      period_num: period,
      value2: multiplier,
    });
  }, [period, multiplier]);

  useEffect(() => {
    setPeriod(indicator.period_num);
    setMultiplier(indicator.value2);
  }, [indicator]);

  return (
    <div>
      <div className="d-flex justify-content-between indicator-setting-form align-items-center above-buy-price above-buy-price2">
        <div>
          <label className="indicator-setting-label">{t("period")}</label>
        </div>
        <div>
          <Form.Control
            as="input"
            type="number"
            min={7}
            max={14}
            {...bindPeriod}
            onKeyPress={(e) => {
              restrictAlphabets(e);
            }}
            className="input-text input-gp-text"
          ></Form.Control>
        </div>
      </div>

      <div className="d-flex justify-content-between indicator-setting-form align-items-center above-buy-price above-buy-price2">
        <div>
          <label className="indicator-setting-label">{t("Factor")}</label>
        </div>
        <div>
          <Form.Control
            as="input"
            type="number"
            {...bindMultiplier}
            step="0.1"
            onKeyPress={(e) => {
              restrictAlphabets(e);
            }}
            className="input-text input-gp-text"
          ></Form.Control>
        </div>
      </div>

      <IsRequiredModule
        indicator={indicator}
        updateIndicator={updateIndicator}
        t={t}
      ></IsRequiredModule>
    </div>
  );
};

export default SuperTrendSetting;
